import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/Language";
import Fundraiser from "@/pages/Fundraiser";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App grain-overlay">
      <LanguageProvider>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Fundraiser />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#1C1A17",
              color: "#F9F6F0",
              border: "1px solid #3a352f",
              borderRadius: "0",
              fontFamily: '"DM Sans", sans-serif',
            },
          }}
        />
      </ReactLenis>
      </LanguageProvider>
    </div>
  );
}

export default App;
